export default "__VITE_ASSET__BN2W_fYl__"